export const SIDEBAR_COUNTS_MAX_AGE_MS = 20_000;

export function viewsHaveTimeFilters(views) {
  return views.some(view => Array.isArray(view.filters?.conditions) && view.filters.conditions.some(condition => ['snoozed', 'ageDays'].includes(condition?.field)));
}
